import { Component, OnInit, HostListener } from '@angular/core';
import { LocaleService } from '../../services/locale.service';

@Component({
    selector: 'app-table-price',
    templateUrl: './table-price.component.html',
    styleUrls: ['./table-price.component.sass']
})

export class TablePriceComponent implements OnInit {

    public isMobile = false;
    public symbol;
    public dataTableServer;
    public isOpenInfoTable = 0;

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.isMobile = window.innerWidth <= 767 ? true : false;
    }


    constructor(
        private localeService: LocaleService
    ) {
        this.symbol = localeService.symbol;
    }

    ngOnInit() {
        this.dataTableServer = this.localeService.getContent().DATA_TABLE_SERVER;
        this.isMobile = window.innerWidth <= 767 ? true : false;
    }

    toggleOnTablet(index) {
        if (window.innerWidth <= 767) {
            this.isOpenInfoTable = index;
        }
    }

    goToUrl(url: string): void {
        window.open(url, '_blank');
    }
}
